import { GatsbyBrowser } from 'gatsby';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { Auth as AuthWrapper } from '~/layout/Auth/Auth';
import { gtmService } from '~/services/gtm';
import { wrapWithProviders } from '~/utils/gatsbyHelpers';

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] =
  wrapWithProviders;

export const replaceHydrateFunction = () => (element, container) => {
  const root = createRoot(container);
  root.render(element);
};

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
  props,
}) => {
  if (!props.location.hash) {
    gtmService.emitPageView(props.pageContext.pageTemplate);
  }

  return <AuthWrapper>{element}</AuthWrapper>;
};

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = () => {
  gtmService.emitRouteChange();
};

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = ({
  routerProps: { location },
}) => !location.state?.noScroll;
